// ============================================================================
// NEW LOOKZ HAIR SALON — CENTRAL EDITABLE BUSINESS CONFIGURATION
// Update this single file to change business details across the whole site.
// Anything unverified is clearly marked with [CONFIRM ...] / [ADD ...] tokens.
// All gallery/hero imagery is licensed stock (Unsplash) used as PLACEHOLDER —
// replace with authorized business photography when supplied by the owner.
// ============================================================================

const img = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=75`;

export const BUSINESS = {
  name: "New Lookz Hair Salon",
  shortName: "NEW LOOKZ",
  tagline: "Modern Urban Grooming Studio",
  phoneDisplay: "+91 88863 93777",
  phoneHref: "tel:+918886393777",
  addressLines: [
    "1-1-744/A/2, Street Number 4,",
    "New Bakaram, Gandhi Nagar,",
    "Kavadiguda, Hyderabad,",
    "Telangana 500080, India",
  ],
  addressFull:
    "1-1-744/A/2, Street Number 4, New Bakaram, Gandhi Nagar, Kavadiguda, Hyderabad, Telangana 500080, India",
  areaShort: "Gandhi Nagar • Hyderabad",

  // EDITABLE trust data — update as the live Google profile changes.
  googleRating: "4.3",
  googleReviewCount: "600+",

  // EDITABLE announcement bar message.
  announcement:
    "Appointments & enquiries welcome — contact us to check availability",

  // EDITABLE opening hours. Empty until verified — a call-to-confirm note shows.
  hours: [], // e.g. { days: "Mon – Sat", time: "10:00 AM – 9:00 PM" }
  hoursNote: "Opening hours to be confirmed — please call ahead",

  // EDITABLE Google Maps configuration (keyless embed — no API key required).
  mapsEmbedUrl:
    "https://maps.google.com/maps?q=New%20Lookz%20Hair%20Salon%2C%201-1-744%2FA%2F2%2C%20Street%20Number%204%2C%20New%20Bakaram%2C%20Gandhi%20Nagar%2C%20Kavadiguda%2C%20Hyderabad%2C%20Telangana%20500080&z=16&output=embed",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent(
      "New Lookz Hair Salon, 1-1-744/A/2, Street Number 4, New Bakaram, Gandhi Nagar, Kavadiguda, Hyderabad, Telangana 500080"
    ),
  googleReviewsUrl:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("New Lookz Hair Salon Gandhi Nagar Kavadiguda Hyderabad"),

  // [ADD SOCIAL PROFILE] — only verified profiles, e.g. { label: "Instagram", href: "https://instagram.com/..." }
  socials: [],

  // EDIT: replace with the final production domain.
  siteUrl: "https://gandhi-nagar-salon.preview.emergentagent.com",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Gallery", to: "/gallery" },
  { label: "About", to: "/about" },
  { label: "Reviews", to: "/reviews" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

// ---------------------------------------------------------------------------
// SERVICES — DRAFT menu. Names/descriptions are editable drafts; prices are
// intentionally "Price on request" until confirmed by the salon.
// ---------------------------------------------------------------------------
export const SERVICE_CATEGORIES = [
  {
    slug: "haircuts",
    title: "Haircuts",
    blurb:
      "Fresh, clean cuts designed around your preferred style and everyday look.",
    image: img("photo-1503951914875-452162b0f3f1", 900),
    imageAlt: "Barber giving a modern men's haircut — stock placeholder",
    services: [
      { name: "Classic Haircut", description: "A clean, well-finished cut shaped to your everyday style. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
      { name: "Skin Fade / Taper", description: "A sharper, modern finish with detailed blending. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
      { name: "Kids Haircut", description: "A patient, comfortable cut for younger clients. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
    ],
  },
  {
    slug: "hair-styling",
    title: "Hair Styling",
    blurb:
      "Styling for everyday occasions and moments when you want a more finished look.",
    image: img("photo-1562322140-8baeececf3df", 900),
    imageAlt: "Stylist shaping hair during a professional styling session — stock placeholder",
    services: [
      { name: "Blow-Dry & Finish", description: "A polished, finished look for any occasion. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
      { name: "Occasion Styling", description: "Styling for events, functions and special days. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
    ],
  },
  {
    slug: "hair-care",
    title: "Hair Care",
    blurb:
      "Hair-focused care designed to help maintain a clean, healthy-looking finish.",
    image: img("photo-1512690459411-b9245aed614b", 900),
    imageAlt: "Relaxing hair wash at a salon basin — stock placeholder",
    services: [
      { name: "Hair Spa / Treatment", description: "A care treatment for a healthier-looking finish. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
      { name: "Head Massage", description: "A relaxing add-on to complete your visit. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
    ],
  },
  {
    slug: "grooming",
    title: "Grooming",
    blurb: "Complete your look with professional grooming services.",
    image: img("photo-1622286342621-4bd786c2447c", 900),
    imageAlt: "Barber detailing a client's beard — stock placeholder",
    services: [
      { name: "Beard Trim & Shape", description: "Sharp lines and a balanced, tidy shape. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
      { name: "Clean Shave", description: "A classic, close and comfortable shave. [CONFIRM SERVICE]", price: "Price on request", duration: "[CONFIRM DURATION]" },
    ],
  },
];

export const WHY_POINTS = [
  {
    title: "Personal Attention",
    text: "A focused approach to understanding the look you want.",
  },
  {
    title: "Convenient Location",
    text: "An accessible local salon in New Bakaram, Gandhi Nagar.",
  },
  {
    title: "Local Reputation",
    text: "A strong local Google presence with hundreds of customer reviews.",
  },
];

// ---------------------------------------------------------------------------
// GALLERY — licensed stock placeholders. Replace with real salon photography.
// ---------------------------------------------------------------------------
export const GALLERY_FILTERS = ["All", "Haircuts", "Styling", "Grooming", "Salon"];

export const GALLERY_IMAGES = [
  { src: img("photo-1503951914875-452162b0f3f1", 900), alt: "Barber finishing a modern men's haircut", category: "Haircuts", ratio: "aspect-[4/5]" },
  { src: img("photo-1585747860715-2ba37e788b70", 900), alt: "Modern barbershop interior with leather chairs", category: "Salon", ratio: "aspect-[4/3]" },
  { src: img("photo-1562322140-8baeececf3df", 900), alt: "Stylist blow-drying hair during a styling session", category: "Styling", ratio: "aspect-[4/5]" },
  { src: img("photo-1622286342621-4bd786c2447c", 900), alt: "Barber trimming and shaping a beard", category: "Grooming", ratio: "aspect-square" },
  { src: img("photo-1621605815971-fbc98d665033", 900), alt: "Close-up of a precision clipper fade", category: "Haircuts", ratio: "aspect-[4/3]" },
  { src: img("photo-1517832606299-7ae9b720a186", 900), alt: "Classic straight-razor shave at a barber chair", category: "Grooming", ratio: "aspect-[4/5]" },
  { src: img("photo-1560066984-138dadb4c035", 900), alt: "Row of styling stations in a contemporary salon", category: "Salon", ratio: "aspect-[4/5]" },
  { src: img("photo-1599351431202-1e0f0137899a", 900), alt: "Stylist working on detailed hair styling", category: "Styling", ratio: "aspect-[4/3]" },
  { src: img("photo-1521590832167-7bcbfaa6381f", 900), alt: "Stylist checking the finish of a haircut", category: "Haircuts", ratio: "aspect-square" },
  { src: img("photo-1512690459411-b9245aed614b", 900), alt: "Hair wash at a salon basin", category: "Salon", ratio: "aspect-[4/5]" },
  { src: img("photo-1493256338651-d82f7acb2b38", 900), alt: "Editorial portrait with styled hair", category: "Styling", ratio: "aspect-[4/5]" },
  { src: img("photo-1595476108010-b4d1f102b1b1", 900), alt: "Hair wash and care at the salon basin", category: "Salon", ratio: "aspect-[4/3]" },
];

export const HERO_IMAGE = {
  src: img("photo-1578390432942-d323db577792", 1400),
  alt: "Professional barber at work in a modern studio — stock placeholder",
};

export const HERO_IMAGE_SMALL = {
  src: img("photo-1517832606299-7ae9b720a186", 700),
  alt: "Detail of classic barber grooming — stock placeholder",
};

export const ABOUT_IMAGE = {
  src: img("photo-1585747860715-2ba37e788b70", 1200),
  alt: "Inside a modern urban salon — stock placeholder",
};

// ---------------------------------------------------------------------------
// REVIEWS — NO fabricated reviews. Placeholders until verified Google
// reviews are supplied. Insert real reviews into this array.
// ---------------------------------------------------------------------------
export const REVIEWS = [
  { name: "[ADD VERIFIED REVIEW]", rating: null, date: "—", text: "Verified Google review will be inserted here.", placeholder: true },
  { name: "[ADD VERIFIED REVIEW]", rating: null, date: "—", text: "Verified Google review will be inserted here.", placeholder: true },
  { name: "[ADD VERIFIED REVIEW]", rating: null, date: "—", text: "Verified Google review will be inserted here.", placeholder: true },
];

// ---------------------------------------------------------------------------
// FAQ — editable answers. Nothing here claims unconfirmed policies.
// ---------------------------------------------------------------------------
export const FAQS = [
  {
    q: "Where is New Lookz Hair Salon located?",
    a: "We are at 1-1-744/A/2, Street Number 4, New Bakaram, Gandhi Nagar, Kavadiguda, Hyderabad, Telangana 500080 — easy to reach from the surrounding Gandhi Nagar and Kavadiguda areas.",
    category: "Location",
  },
  {
    q: "How can I contact the salon?",
    a: "Call us on +91 88863 93777 for appointments, service questions or directions. You can also send an enquiry through our contact form.",
    category: "Booking",
  },
  {
    q: "What are the opening hours?",
    a: "Please call +91 88863 93777 to confirm current opening hours before your visit. Verified hours will be published here soon. [CONFIRM HOURS]",
    category: "Hours",
  },
  {
    q: "Do I need an appointment?",
    a: "Appointments and enquiries are welcome — contact us to check availability. Our walk-in policy will be confirmed by the salon. [CONFIRM POLICY]",
    category: "Appointments",
  },
  {
    q: "What services do you offer?",
    a: "Our draft menu covers haircuts, hair styling, hair care and grooming. The full, confirmed service list and prices will be published shortly — call us for today's availability.",
    category: "Services",
  },
  {
    q: "How can I get directions?",
    a: "Use the “Get Directions” button anywhere on this site — it opens Google Maps navigation straight to our door in New Bakaram, Gandhi Nagar.",
    category: "Location",
  },
  {
    q: "How can I book an appointment?",
    a: "Use the Book Appointment page to request a time, or call +91 88863 93777. Your requested time is not confirmed until the salon responds.",
    category: "Booking",
  },
  {
    q: "How much do services cost?",
    a: "Prices are currently listed as “Price on request” while the salon confirms its menu. Call us for current pricing. [CONFIRM PRICE]",
    category: "Pricing",
  },
  {
    q: "What payment methods do you accept?",
    a: "Payment options will be confirmed by the salon. [CONFIRM PAYMENTS]",
    category: "Payments",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Craft First",
    text: "Every cut starts with listening. The look you want — not the look you're given — guides every detail of the chair time.",
  },
  {
    n: "02",
    title: "Comfort Always",
    text: "Getting your hair done should feel simple and unhurried. A clean, calm studio in the middle of your own neighbourhood.",
  },
  {
    n: "03",
    title: "Local by Nature",
    text: "New Bakaram, Gandhi Nagar is home. We serve the people we share streets with — and that keeps our standards personal.",
  },
];

// [ADD BUSINESS STORY] — to be supplied by the owner.
export const BUSINESS_STORY = "Business story to be supplied by owner.";
